import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import { AI_COLORS } from '../aiAnalyticsConstants';

const SELECTED_SURFACE = alpha(AI_COLORS.brand, 0.04);

export default function SummaryCard({ icon, label, count, selected, disabled, onClick }) {
  return (
    <Card
      variant="outlined"
      sx={{
        flex: 1,
        maxWidth: 320,
        borderColor: selected ? AI_COLORS.brand : 'divider',
        borderWidth: selected ? 2 : 1,
        backgroundColor: selected ? SELECTED_SURFACE : 'background.paper'
      }}
    >
      <CardActionArea onClick={onClick} disabled={disabled} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box sx={{ color: AI_COLORS.brand, display: 'flex' }}>{icon}</Box>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
              {label}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, color: AI_COLORS.brand }}>
              {count}
            </Typography>
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  );
}
